export default [
  {
    model_type: 'article',
    id: -100,
    title: '',
    image: {
      model_type: 'image',
      id: -100,
      alt: null,
      preview: '/partners/maer.jpg',
    },
    model_subtype: 'article',
    outer_link: 'https://maergroup.ru/',
  },
  {
    model_type: 'article',
    id: -99,
    title: '',
    image: {
      model_type: 'image',
      id: -100,
      alt: null,
      preview: '/partners/ismo.png',
    },
    model_subtype: 'article',
    outer_link:
      'https://edsoo.ru/federalnyj-konkurs-metodicheskih-razrabotok-po-istoricheskomu-prosveshheniyu-2026/',
  },
  {
    model_type: 'article',
    id: -98,
    title: '',
    image: {
      model_type: 'image',
      id: -100,
      alt: null,
      preview: '/partners/thousands_of_names.jpg',
    },
    model_subtype: 'article',
    outer_link: 'https://1000-names.ru/',
  },
];
